const universalImportSettings = {
  ignoreBabelRename: true,
};

export default universalImportSettings;
